import axios, { AxiosResponse } from 'axios';
import { action, atom, onMount } from 'nanostores';
import {
  Experiment,
  ExperimentService,
  CreateExperimentRequest,
  ExperimentAssignment,
  WorkflowNotificationTask,
  WorkflowsService,
  ExecuteWorkflowNotificationTaskRequest,
} from '../api';


export const $loadingTasks = atom<boolean>(false);

export const $task = atom<WorkflowNotificationTask | undefined>();

export const $tasks = atom<WorkflowNotificationTask[]>([]);


/**
 * Main function to load tasks.
 */
export const loadTasks = async (organizationId: string) => {
  console.log('Retrieving tasks ...');
  $loadingTasks.set(true); // Set loading state to true
  await ensureOrganization(organizationId);

  var response = await WorkflowsService.getWorkflowNotificationTasks(organizationId);
  $tasks.set(response ?? []);

  $loadingTasks.set(false); // Set loading state back to false
};

export const getTasks = action(
  $tasks,
  'getTasks',
  async (store, organizationId: string | undefined) => {
    if (organizationId == undefined) {
      return;
    }

    const response = await WorkflowsService.getWorkflowNotificationTasks(organizationId);

    $tasks.set(response);
  },
);

export const updateTask = action(
  $task,
  'updateTask',
  async (store, taskId: string, organizationId: string | undefined, request) => {
    if (organizationId == undefined) {
      return;
    }
    
    const response = await WorkflowsService.executeWorkflowNotificationTask(organizationId, taskId, request);
    return response;
  },
);  


/**
 * Watch for route changes; if we haven't loaded the score logics, we try to load them.
 */
route.subscribe(async name => {
  // Add a small delay to ensure state is settled

  if (name !== 'tasks' || ($tasks.value?.length ?? 0) > 0) {
    return;
  }

  const params = $router.get()?.params as Record<'organizationId', string>;
  await loadTasks(params.organizationId);
});


/**
 * Ensure that the indicator scores is loaded and selected.
 */
export const ensureTask = action(
  $task,
  'ensureTask',
  async (store, taskId: string) => {
    let task: WorkflowNotificationTask | undefined;

    const params = $router.get()?.params as Record<'organizationId', string>;
    
    if ($tasks.get().length === 0) {
      const tasks = await WorkflowsService.getWorkflowNotificationTasks(
        params.organizationId ?? '',
      );

      $tasks.set(tasks);
      task = tasks.find(p => p.id === taskId);
    } else {
      task = $tasks.get().find(p => p.id === taskId);
    }
    

    $task.set(task);
  },
);  